module.exports = __webpack_public_path__ + "media/components/Inbox/Conversation/Messages/logo-small-64135de96c30c36259621d462be12c55.svg";